import Swal from 'sweetalert2';
import { questionSubscriptionTarget } from '../../questionBank/paidQuestionFlow';

export function noteNeedsPurchase(note = {}, allowExistingReward = false) {
  const raw = note.raw || note;
  const paid = String(note.freePaid ?? raw.free_paid ?? 'F').toUpperCase() === 'P';
  if (!paid || Number(note.paymentStatus ?? raw.payment_status) === 1) return false;
  const rewarded = Boolean(raw.ad_reward_id) && Number(raw.ad_access_available) === 1 && Number(raw.remaining_notes) > 0;
  return !(allowExistingReward && rewarded);
}

export async function promptNoteSubscription(note, context, navigate, metadata = {}) {
  const result = await Swal.fire({ icon: 'info', title: 'Locked Note',
    text: note.subscriptionMessage || note.raw?.subscription_message || 'Subscribe to unlock this note.',
    confirmButtonText: 'Subscribe', showCancelButton: true, cancelButtonText: 'Cancel' });
  if (result.isConfirmed) {
    const target = questionSubscriptionTarget(note, { ...context, categoryId: 4 }, metadata);
    navigate(target.pathname, { state: target.state });
  }
}

export function noteDetailFlow(note, context = {}, metadata = {}) {
  const target = questionSubscriptionTarget(note, { ...context, categoryId: 4 }, metadata).state;
  const subjectId = Number(note.raw?.subject_id || note.subjectId || context.subject_id || context.selectedSubject?.id || 0);
  return { ...context, ...target, state_id: target.stateId, states_id: target.stateId,
    selectedState: { ...context.selectedState, state_id: target.stateId },
    selectedSubject: { ...context.selectedSubject, id: subjectId, subject_id: subjectId },
    subject_id: subjectId,
    category_id: 4, selectedNote: note, note_id: Number(note.id),
    ...(target.examId ? { exam_id: target.examId } : {}) };
}
